<template>
  <div class="list-class">
    <div class="tips" id="tips"></div>
    <van-tabs
      v-model="active"
      v-if="loginTrue"
      @click="onClickTab"
      animated
      color="#1e90ff"
    >
      <!-- <van-tab title="团体报告"></van-tab>
      <van-tab title="个人报告"></van-tab>-->
      <van-tab v-for="(item, index) in tabTitles" :title="item" :key="index">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
        >
          <van-grid
            v-for="(item, index) in list"
            :key="index"
            :title="item"
            :center="true"
          >
            <div
              v-if="active == 0"
              class="list-item"
              @click="clickItem(item.id, item.qtId)"
            >
              <p class="new" v-if="item.readFlag == 0">NEW</p>
              <div class="right-class">
                <span class="text-class">量表名称：{{ item.qtName }}</span>
                <span class="click-class">测试时间：{{ item.createTime }}</span>
              </div>
            </div>
            <div class="item-class" v-if="active == 1">
              <p class="text-class">
                评测机构 : {{ item.companyName }} / {{ item.departmentName1 }} /
                {{ item.departmentName2 }}
              </p>
              <p class="new" v-if="item.readFlag == 0">NEW</p>
              <div>
                <span class="status-class" :style="{ color: item.color }">{{
                  item.showStatus
                }}</span>

                <span class="time-class" v-if="item.startTime">{{
                  difference(item.startTime, item.endTime)
                }}</span>
                <!-- v-if="item.status == -1" -->
                <a class="intervene-class">反馈训练</a>
              </div>
              <div class="prompt-class">
                <span class="statusPrompt-class text-class">状态</span>
                <span class="timePrompt-class text-class">时长</span>
              </div>
              <span class="endTime-class text-class"
                >评测时间: {{ item.endTime }}</span
              >
              <a @click="clickMyReport(item)" class="look-class"
                >查看个人报告</a
              >
            </div>
          </van-grid>
        </van-list>
      </van-tab>
    </van-tabs>
    <div class="back" v-if="isAndroid && loginTrue" @click="backHome">返回</div>
    <Login v-if="loginTk" />
    <ChoiceCompany
      :choiceTk="choiceTk"
      :mobile="mobile"
      :companyList="companyList"
      v-if="choiceTk"
    />
    <van-dialog
      :style="windowPc ? 'width: 60%' : ''"
      v-model="dialogShow"
      showCancelButton
      confirmButtonText="确定"
      :beforeClose="beforeClose"
      title="完善姓名后查看报告"
    >
      <div class="name">
        姓名：<input type="text" v-model="name" placeholder="请输入您的姓名" />
      </div>
    </van-dialog>
  </div>
</template> 
<script>
import wx from "weixin-js-sdk";
import serivce from "@/utils/ajax";
import ChoiceCompany from "./components/choiceCompany.vue";
import Login from "./components/login.vue";
export default {
  name: "LookReport",
  components: {
    Login,
    ChoiceCompany,
  },
  data() {
    return {
      dialogShow: false,
      tabTitles: ["心理量表", "情绪测评/干预训练"],
      dateDiff: "",
      list: [],
      loading: false,
      finished: false,
      active: 0,
      isAndroid: false,
      windowPc: false,
      name: "",
      scaleId: "",

      loginTk: false,
      mobile: "",
      companyList: [],
      choiceTk: false,
      loginTrue: true,
    };
  },
  created(){
    if(this.$route.query.app_secret){
      sessionStorage.setItem("app_secret", this.$route.query.app_secret)
      localStorage.setItem("userInfo", this.$route.query.userInfo)
    }
  },
  mounted() {
    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      this.windowPc = false;
    } else {
      this.windowPc = true;
    }
    var u = navigator.userAgent;
    this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
    this.active = this.$route.query.type ? this.$route.query.type - 0 : 0;

    document.title = this.$route.query.from;
    if (
      !localStorage.getItem("IntegratedTitle") ||
      !localStorage.getItem("userInfo")
    ) {
      localStorage.setItem("IntegratedTitle", this.$route.query.from);
      this.loginTk = true;
      this.loginTrue = false;
    } else {
      this.getList(this.active);
    }
    if(this.$route.query.app_secret){
      this.getList(this.active)
      this.isAndroid = false
    }
    if (
      sessionStorage.getItem("loginTk") &&
      sessionStorage.getItem("loginMsg")
    ) {
      this.loginTk = sessionStorage.getItem("loginTk");
    }
  },
  methods: {
    beforeClose(action, done) {
      if (action === "confirm") {
        if (this.name != "") {
          let datas = {
            phone: JSON.parse(localStorage.getItem("userInfo")).phone,
            companyId: JSON.parse(localStorage.getItem("userInfo")).companyId,
            name: this.name,
          };
          serivce.post(`/sp_api/spUser/update`, datas).then((res) => {
            if (res.code == 0) {
              this.pupUp(res.msg);
              let userInfo = JSON.parse(localStorage.getItem("userInfo"));
              userInfo.userName = this.name;

              localStorage.setItem("userInfo", JSON.stringify(userInfo));
              setTimeout(() => {
                this.toReport(this.scaleId);
                done();
              }, 1000);
            } else {
              this.pupUp(res.msg);
            }
          });
        } else {
          this.pupUp("请输入姓名后提交");
          done(false);
        }

        // done(); //关闭
      } else if (action === "cancel") {
        this.name = "";
        done(); //关闭
      }
    },
    backHome() {
      this.$router.push({
        path: "/IntegratedMy?title=" + this.$route.query.from,
      });
    },
    tabCompany(companyList, phone) {
      this.mobile = phone;
      this.companyList = companyList;
      this.choiceTk = true;
    },
    // 点击列表
    clickItem(id, qtId) {
      let userName = JSON.parse(localStorage.getItem("userInfo")).userName;
      this.scaleId = id;
      if (userName && userName != "") {
        this.toReport(id, qtId);
      } else {
        this.dialogShow = true;
      }
    },
    toReport(id, qtId) {
      serivce.get(`/api/qa//report/${id}`, "").then((res) => {
        if (res.status == 200) {
          if (qtId == 2057) {
            this.$router.push({
              path: `/ScaleHxqChild?report=${encodeURIComponent(
                JSON.stringify(res.data.report)
              )}&from=${this.$route.query.from}`,
            });
          } else if (
            qtId == 2074 ||
            qtId == 2052 ||
            qtId == 2073 ||
            qtId == 110
          ) {
            this.$router.push({
              path: `/ScaleHxq?report=${encodeURIComponent(
                JSON.stringify(res.data.report)
              )}&from=${this.$route.query.from}`,
            });
          } else {
            this.$router.push({
              path: `/ScaleReport?report=${encodeURIComponent(
                JSON.stringify(res.data.report)
              )}&from=${this.$route.query.from}`,
            });
          }
        } else {
          this.pupUp(res.msg);
        }
      });
    },
    onClickTab(index, title) {
      this.active = index;
      this.getList();
    },
    getList() {
      this.loginTrue = true;
      this.loginTk = false;
      this.choiceTk = false;
      let companyId = 171,
        phone = 0;
      if (localStorage.getItem("userInfo")) {
        companyId = JSON.parse(localStorage.getItem("userInfo")).companyId;
        phone = JSON.parse(localStorage.getItem("userInfo")).phone;
      }
      if (this.active == 0) {
        let datas = {
          phone: phone,
          companyId: companyId - 0,
        };
        serivce
          .get(`/api/qa//minicode/getMyReportList`, datas)
          .then((res) => {
            if (res.status == 200) {
              console.log(res.data);
              this.list = res.data;
              this.loading = false;
              this.finished = true;
            } else {
              this.list = [];
              this.loading = false;
              this.finished = true;
              this.pupUp(res.msg);
            }
          });
      }
      if (this.active == 1) {
        serivce
          .get(`/api/reportMember/findByMobile/${phone}`, "")
          .then((res) => {
            if (res.status == 200) {
              this.list = res.data;
              this.loading = false;
              this.finished = true;
            } else {
              this.list = [];
              this.pupUp(res.msg);
            }
          });
      }
    },
    clickMyReport(row) {
      const params = {
        // src: row.src,
        src: 3,
        rid: row.reportId,
        from: this.title,
      };
      this.$router.push({ path: "/MyReport", query: params });
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
    difference(beginTime, endTime) {
      const newBegin = beginTime.replace(/\-/gm, "/");
      const newEnd = endTime.replace(/\-/gm, "/");
      var dateBegin = new Date(newBegin);
      var dateEnd = new Date(newEnd);
      var dateDiff = dateEnd.getTime() - dateBegin.getTime(); //时间差的毫秒数
      var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)); //计算出相差天数
      var leave1 = dateDiff % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
      var hours = Math.floor(leave1 / (3600 * 1000)); //计算出小时数
      //计算相差分钟数
      var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
      var minutes = Math.floor(leave2 / (60 * 1000)); //计算相差分钟数
      //计算相差秒数
      var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
      var seconds = Math.round(leave3 / 1000);
      let time = hours + "时" + minutes + "分" + seconds + "秒";
      return time;
    },
  },
};
</script>

<style lang="less" scoped>
.list-class {
  min-height: 100vh;
  background-color: rgb(247, 247, 247);
}
.list-item {
  width: 100%;
  height: 1.9rem;
  display: flex;
  flex-direction: row;
  background-color: white;
  border-bottom: 1px solid gainsboro;
  flex-wrap: wrap;
  position: relative;
  .new {
    position: absolute;
    font-size: 0.32rem;
    right: 0.3rem;
    color: red;
  }
  .right-class {
    flex: 1;
    width: 100%;
    margin-left: 0.3rem;
    text-align: left;
    font-size: 0.32rem;
    padding: 0.4rem 0.3rem 0.4rem 0;
    display: flex;
    flex-wrap: wrap;
  }

  .img-class {
    margin-top: 0.2rem;
    margin-left: 0.3rem;
    background-color: white;
    width: 2rem;
    height: 1.4rem;
    flex-shrink: 0;
    border-radius: 0.16rem;
  }
  .text-class {
    width: 100%;
  }
  .click-class {
    font-size: 0.26rem;
    color: #999;
  }
}
.item-class {
  border-radius: 10px;
  width: 95%;
  margin: 5px 10px 5px 10px;
  border-right: 5px;
  background-color: white;
  font-size: 14px;
  position: relative;
  .new {
    position: absolute;
    right: 0.3rem;
    font-size: 0.3rem;
    top: 0;
    color: red;
  }

  .text-class {
    margin: 10px;
    color: #646566;
    font-size: 12px;
  }

  .status-class {
    font-size: 16px;
    margin-left: 10px;
    font-weight: 600;
  }

  .time-class {
    color: #333333;
    font-size: 16px;
    margin-left: 50px;
    font-weight: 600;
  }

  .prompt-class {
    .statusPrompt-class {
      margin-left: 10px;
    }

    .timePrompt-class {
      margin-left: 80px;
    }
  }

  .endTime-class {
    line-height: 20px;
  }

  .look-class {
    color: rgb(72, 154, 251);
    line-height: 20px;
    float: right;
    font-size: 14px;
    margin-right: 20px;
    font-size: 12px;
    margin-bottom: 5px;
  }
  .intervene-class {
    font-size: 0.24rem;
    float: right;
    line-height: 0.4rem;
    margin-right: 20px;
    // margin-right: 0.7rem;
    margin-top: 0.15rem;
  }
  .star_status1 {
    color: rgb(255, 131, 107);
  }

  .star_status2 {
    color: rgb(249, 117, 31);
  }

  .star_status3 {
    color: rgb(42, 89, 117);
  }

  .star_status4 {
    color: rgb(136, 201, 135);
  }

  .star_status5 {
    color: rgb(158, 72, 169);
  }
}
.back {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0.8rem;
  // padding: 0.2rem 0.3rem;
  background: #f7f7f7;
  line-height: 0.8rem;
  font-size: 0.32rem;
  // padding-left: 0.4rem;
  text-align: center;
}
.name {
  text-align: center;
  margin: 0.5rem 0;
  font-size: 0.3rem;
  input {
    border-radius: 0.1rem;
    outline: none;
    border: 0.02rem solid #999;
    border-radius: 0.08rem;
    height: 0.58rem;
    padding: 0 0.2rem;
  }
}
</style>
